import {Display} from "./Display";

export class Slider
{
    constructor()
    {
        const sliderimage = document.getElementById('container')
                ? document.getElementById('container').querySelector('.slideshow-img,.slideshow-video')
                : false;
        if(sliderimage)
        {
            this.container = sliderimage.closest('.spalte');
            this.slideTimer = 5000;
            this.slides = [];
            const slides = this.container.querySelectorAll('.slideshow-img,.slideshow-video,.a-lazyload');
            if(slides.length > 1)
            {
                for(let i = 0; i < slides.length; i++)
                {
                    this.slides[i] = slides[i];
                }
                this.legend = this.container.querySelector('.slideshow-legende');
                this.add_nav();
                this.add_events();
                this.activeSlideNo = 0;
                this.timer = setInterval(() =>
                {
                    this.next_slide(1);
                }, this.slideTimer);
            }
        }
    }

    add_nav() {
        this.legend.classList.add('multi');

        const prev = document.createElement('a');
        prev.className = 'fa fa-chevron-circle-left slideshow-button slideshow-button-prev';

        const next = document.createElement('a');
        next.className = 'fa fa-chevron-circle-right slideshow-button slideshow-button-next';

        this.legend.appendChild(prev);
        this.legend.appendChild(next);
    }

    add_events()
    {
        this.container.addEventListener('click', e => {
            const el = e.target;
            if(el.classList.contains('slideshow-button-prev'))
            {
                clearInterval(this.timer);
                this.next_slide(-1);
            }
            else if(el.classList.contains('slideshow-button-next'))
            {
                clearInterval(this.timer);
                this.next_slide(1);
            }
            else if(el.classList.contains('w__video') ||
                    el.classList.contains('w__video--play'))
            {
                clearInterval(this.timer);
            }
        });
    }

    next_slide(add)
    {
        let newSlideNo = this.activeSlideNo + add;
        if(newSlideNo === this.slides.length)
        {
            newSlideNo = 0;
        }
        else if(newSlideNo < 0)
        {
            newSlideNo = this.slides.length - 1;
        }

        if(this.slides[newSlideNo].classList.contains('a-lazyload'))
        {
            this.load_image(newSlideNo, (add > 0));
        }
        else
        {
            this.switch_slide(newSlideNo, (add > 0));
        }
    }

    load_image(newSlideNo, forward)
    {
        const src = this.adjust_imagePath(
            this.slides[newSlideNo].href,
            this.container.getBoundingClientRect()['width']);

        const myImage = new Image;
        myImage.classList.add('slideshow-img');
        myImage.src = src;
        myImage.alt = '';
        myImage.title = this.slides[newSlideNo].title;
        myImage.style.opacity = '0';
        myImage.addEventListener('load',() =>
        {
            this.slides[newSlideNo].insertAdjacentElement('afterend', myImage);
            this.slides[newSlideNo].remove();
            this.slides[newSlideNo] = myImage;
            this.switch_slide(newSlideNo, forward);
        });
    }

    adjust_imagePath(imgSrc, sizeX)
    {
        sizeX *= Display.dpi;

        let srcPath,
            targetPath;

        if(imgSrc.match(/\/2x1\//))
        {
            if(sizeX <= 350)
            {
                targetPath = 'b350';
            }
            else if(sizeX <= 700)
            {
                targetPath = 'b700';
            }
            else
            {
                targetPath = 'b1050';
            }
            targetPath = '/2x1/' + targetPath + "/";

            if(imgSrc.match(/\/b350\//))
            {
                srcPath = 'b350';
            }
            else if(imgSrc.match(/\/b700\//))
            {
                srcPath = 'b700';
            }
            else
            {
                srcPath = 'b1050';
            }
            srcPath = '/2x1/' + srcPath + "/";
        }

        return imgSrc.replace(srcPath, targetPath);
    }

    switch_slide(newSlideNo, forward)
    {
        let oldTransform, newTransform;
        if(forward)
        {
            oldTransform = '-200px';
            newTransform = '200px';
        }
        else
        {
            oldTransform = '200px';
            newTransform = '-200px';
        }

        this.slides[newSlideNo].style.transition = 'none';
        this.slides[newSlideNo].style.transform = 'translateX(' + newTransform + ')';
        this.slides[newSlideNo].offsetHeight;
        this.slides[newSlideNo].style.transition = '';
        this.slides[newSlideNo].style.zIndex = '1';

        this.slides[this.activeSlideNo].style.zIndex = '0';
        this.slides[this.activeSlideNo].style.opacity = '0';
        this.slides[this.activeSlideNo].style.transform = 'translateX(' + oldTransform + ')';
        this.slides[newSlideNo].style.opacity = '1';
        this.slides[newSlideNo].style.transform = '';
        this.activeSlideNo = newSlideNo;
        this.legend.querySelector('.slideshow-legende-text').textContent = this.slides[newSlideNo].title;
    }
}